import http from '@/utils/http';
import { ref } from '@vue/composition-api';
export default () => {
  const codeUid = ref('');
  const graphicCode = ref('');
  // 获取验证码
  const getCode = async () => {
    const { codeSvg, uid, err } = (await http.post('/hospital/getCode', {})) as any;
    if (err) {
      throw new Error('弹窗拦截');
    }
    codeUid.value = uid;
    graphicCode.value = codeSvg;
  };
  return {
    codeUid,
    graphicCode,
    getCode,
  };
};
